const angular = require('angular');

const { SettingsService } = require('./settings.service');
const { settings, settingDefaults } = require('./settings.constants');
const { SettingsByBreakpointService } = require('./settings-by-breakpoint.service');
const settingsDirectiveDefinition = require('./settings.directive');
const htmlSettingDirectiveDefinition = require('./settings-html.directive');

angular.module('wowApp.common')
    .run(require('./settings.config'))
    .constant('Settings', settings)
    .constant('SettingDefaults', settingDefaults)
    .service('SettingsService', SettingsService)
    .service('SettingsByBreakpointService', SettingsByBreakpointService)
    .directive('wowSetting', ['SettingsService', settingsDirectiveDefinition])
    .directive('wowHtmlSetting', ['SettingsService', htmlSettingDirectiveDefinition]);



// WEBPACK FOOTER //
// ./src/common/settings/index.js